import { render, staticRenderFns } from "./todayPlayerPointSpecial.vue?vue&type=template&id=390459ae&scoped=true&"
import script from "./todayPlayerPointSpecial.vue?vue&type=script&lang=js&"
export * from "./todayPlayerPointSpecial.vue?vue&type=script&lang=js&"
import style0 from "./todayPlayerPointSpecial.vue?vue&type=style&index=0&id=390459ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390459ae",
  null
  
)

export default component.exports